import React from 'react';
import styles from './AboutPage.module.scss';
import { About } from '../../components/About';
import { Footer } from '../../components/Footer';
import { NavBar } from '../../components/NavBar';

export default function AboutPage() {
  return (
    <div className={styles.root}>
      <NavBar />
      <div className={styles.mainContent}>
        <About />
      </div>
      <Footer />
    </div>
  );
}